import { render, staticRenderFns } from "./HsabRepayClaimExpanded.vue?vue&type=template&id=c1455df0"
import script from "./HsabRepayClaimExpanded.vue?vue&type=script&lang=ts"
export * from "./HsabRepayClaimExpanded.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports